const LockActions = {
    LOCKSET_CREATED: "lock/lockset-created",
    LOCKSET_CREATE_ERROR: "lock/lockset-create-error",
    LOCKSET_RELEASED: "lock/lockset-released",
    LOCKSET_RELEASE_ERROR: "lock/lockset-release-error",
    LOCKSET_CONFIRMED: "lock/lockset-confirmed",
    LOCKSET_CONFIRM_ERROR: "lock/lockset-confirm-error",
};

export default LockActions;



// WEBPACK FOOTER //
// ./app/data/LockActions.js